/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubmittedJob } from './SubmittedJob';
import {TransientCalculationPoint} from "./TransientCalculationPoint";
/**
 * Drive Cycle in Database.
 */
export type DriveCycleS3InDB = {
    item_type?: DriveCycleS3InDB.item_type;
    name?: string;
    submitted_job: SubmittedJob;
    _id?: string;
    points?: Array<TransientCalculationPoint>; // TODO: Adding manually to compile GetDriveCycleDataAction which uses readDriveCyclesItemIdGet()
};
export namespace DriveCycleS3InDB {
    export enum item_type {
        DRIVE_CYCLE = 'drive_cycle',
    }
}

